import type { FAQItem } from './accordion-data.types';

export const FAQ_BIKE_DATA: FAQItem[] = [
    {
        question: 'Para que serve a Tabela Fipe?',
        answer: 'A Tabela Fipe apresenta os preços médios de venda à vista de carros e motos praticados para o consumidor final, pessoa física, no mercado brasileiro. Ela serve como uma referência para negociações e avaliações, oferecendo um parâmetro base para quem vai comprar ou vender.',
        questionJSX: <h3 data-testid="faq-question-07" id="faq-question-07">Para que serve a Tabela Fipe?</h3>,
        answerJSX: (
            <div data-testid="faq-content-07" id="faq-content-07">
                <p data-testid="faq-content-07-p1" id="faq-content-07-p1">
                    A Tabela Fipe apresenta os preços médios de venda à vista de carros e motos praticados para o
                    consumidor final, pessoa física, no mercado brasileiro. Ela serve como uma referência para
                    negociações e avaliações, oferecendo um parâmetro base para quem vai comprar ou vender.
                </p>
            </div>
        ),
    },
    {
        question: 'Quando usar a Tabela Fipe Motos?',
        answer: 'A Tabela Fipe Motos pode ser usada quando você quiser consultar preços de motocicletas, seja para compra ou venda. Além disso, ela também pode ser utilizada, por exemplo, para calcular o Imposto sobre Propriedade de Veículos Automotores (IPVA).',
        questionJSX: <h3 data-testid="faq-question-08" id="faq-question-08">Quando usar a Tabela Fipe Motos?</h3>,
        answerJSX: (
            <div data-testid="faq-content-08" id="faq-content-08">
                <p data-testid="faq-content-08-p1" id="faq-content-08-p1">
                    A Tabela Fipe Motos pode ser usada quando você quiser consultar preços de motocicletas, seja
                    para compra ou venda. Além disso, ela também pode ser utilizada, por exemplo, para calcular o
                    Imposto sobre Propriedade de Veículos Automotores (IPVA).
                </p>
            </div>
        ),
    },
    {
        question: 'Como consultar Tabela Fipe de Moto?',
        answer: 'É muito fácil fazer a consulta e descobrir o valor da Tabela Fipe para um modelo de moto. Basta selecionar as seguintes informações do modelo que quiser avaliar: 1. Marca do modelo. 2. Nome do modelo. 3. Ano do modelo. 4. Estado para o qual pretende avaliar a compra ou venda. 5. Depois é só clicar em "Consultar Valor".',
        questionJSX: <h3 data-testid="faq-question-09" id="faq-question-09">Como consultar Tabela Fipe de Moto?</h3>,
        answerJSX: (
            <div data-testid="faq-content-09" id="faq-content-09">
                <p data-testid="faq-content-09-p1" id="faq-content-09-p1">
                    É muito fácil fazer a consulta e descobrir o valor da Tabela Fipe para um modelo de moto. Basta
                    selecionar as seguintes informações do modelo que quiser avaliar:
                </p>
                <div
                    className="accordion-content-list"
                    data-testid="faq-content-09-list"
                    id="faq-content-09-list"
                >
                    <p data-testid="faq-content-09-list-item-1" id="faq-content-09-list-item-1">1. Marca do modelo.</p>
                    <p data-testid="faq-content-09-list-item-2" id="faq-content-09-list-item-2">2. Nome do modelo.</p>
                    <p data-testid="faq-content-09-list-item-3" id="faq-content-09-list-item-3">3. Ano do modelo.</p>
                    <p data-testid="faq-content-09-list-item-4" id="faq-content-09-list-item-4">4. Estado para o qual pretende avaliar a compra ou venda.</p>
                    <p data-testid="faq-content-09-list-item-5" id="faq-content-09-list-item-5">5. Depois é só clicar em "Consultar Valor".</p>
                </div>
            </div>
        ),
    },
    {
        question: 'Qual ano considerar na Tabela Fipe?',
        answer: 'A Tabela Fipe é atualizada todos os meses e considera a marca, o modelo e o ano do veículo, sendo que o ano levado em conta é sempre o do modelo, e não o de fabricação. Os valores são expressos em reais, com base no mês e ano de referência, e não incluem veículos destinados a uso profissional ou especial.',
        questionJSX: <h3 data-testid="faq-question-10" id="faq-question-10">Qual ano considerar na Tabela Fipe?</h3>,
        answerJSX: (
            <div data-testid="faq-content-10" id="faq-content-10">
                <p data-testid="faq-content-10-p1" id="faq-content-10-p1">
                    A Tabela Fipe é atualizada todos os meses e considera a marca, o modelo e o ano do veículo,
                    sendo que o ano levado em conta é sempre o do modelo, e não o de fabricação. Os valores são
                    expressos em reais, com base no mês e ano de referência, e não incluem veículos destinados a uso
                    profissional ou especial.
                </p>
            </div>
        ),
    },
    {
        question: 'Tabela Webmotors: o que é?',
        answer: 'É a nossa referência de preços para modelos de carros e motos. Na Webmotors, comparamos o valor de tabela Fipe com os preços reais praticados no mercado, levando em consideração as transações realizadas dentro da nossa plataforma. Essa é a Tabela Webmotors. Dessa forma, você tem acesso a uma análise mais precisa e fiel aos valores praticados no mercado.',
        questionJSX: <h3 data-testid="faq-question-11" id="faq-question-11">Tabela Webmotors: o que é?</h3>,
        answerJSX: (
            <div data-testid="faq-content-11" id="faq-content-11">
                <p data-testid="faq-content-11-p1" id="faq-content-11-p1">
                    É a nossa referência de preços para modelos de carros e motos. Na Webmotors, comparamos o valor
                    de tabela Fipe com os preços reais praticados no mercado, levando em consideração as transações
                    realizadas dentro da nossa plataforma. Essa é a Tabela Webmotors. Dessa forma, você tem acesso a
                    uma análise mais precisa e fiel aos valores praticados no mercado.
                </p>
            </div>
        ),
    },
];
